import {useRef, useState} from "react";
import {Calendar} from "react-date-range";
import styled from "styled-components";
import theme from "../../style/theme";
import {convertYYYYMMDDddFormat} from "../../utils/date/date-format";
import CalendarLineIcon from "../icons/CalendarLineIcon/CalendarLineIcon";
import {useClickOutside} from "../../utils/click/handle-click";

interface Props {
    selectedDate: Date;
    setSelectedDate: (date: Date) => void;
}

export const RoutingServiceDateCalendar: React.FC<Props> = (
    {
        selectedDate,
        setSelectedDate,
    }
) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleClickBox = () => {
        setOpen(!open);
    };

    useClickOutside(ref, () => setOpen(false));

    return (
        <Container ref={ref}>
            <BasicCalendarContainer onClick={handleClickBox} open={open}>
                <IconContainer>
                    <CalendarLineIcon
                        width="18px"
                        height="18px"
                        fill={theme.palette.primitives.yellow400}
                    />
                </IconContainer>
                <DateContainer>{`배송일 : ${convertYYYYMMDDddFormat(
                    selectedDate
                )}`}</DateContainer>
            </BasicCalendarContainer>
            {open && (
                <CalendarContainer>
                    <Calendar
                        editableDateInputs={true}
                        date={selectedDate}
                        onChange={(item) => setSelectedDate(item)}
                        color={theme.palette.primitives.yellow400}
                    />
                </CalendarContainer>
            )}
        </Container>
    );
};

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

interface BasicCalendarContainerProps {
    open: boolean;
}

const BasicCalendarContainer = styled.div<BasicCalendarContainerProps>`
  width: 212px;
  height: 42px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: ${theme.palette.primitives.white};
  border: 1px solid ${(props) =>
          props.open
                  ? theme.palette.primitives.gray600
                  : theme.palette.primitives.gray200};
  box-sizing: border-box;

  &:hover {
    background: ${theme.palette.primitives.gray50};
  }
`;

const IconContainer = styled.div`
  margin: 12px 4px 12px 12px;
  width: 18px;
  height: 18px;
  padding: 0;
`;

const DateContainer = styled.div`
  padding: 0;
  margin: 0;
  width: fit-content;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  text-align: left;
  font-weight: 500;
  font-size: 15px;
  line-height: normal;
  letter-spacing: 0.6px;
  color: ${theme.palette.primitives.gray900};
`;

const CalendarContainer = styled.div`
  position: absolute;
  margin-top: 2.5rem;

  .rdrDayToday .rdrDayNumber span:after {
    background-color: ${theme.palette.primitives.yellow400};
  }

  .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: black;
  }

  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;
